import { render, staticRenderFns } from "./eventListEdit.vue?vue&type=template&id=36cf2330&scoped=true"
import script from "./eventListEdit.vue?vue&type=script&lang=js"
export * from "./eventListEdit.vue?vue&type=script&lang=js"
import style0 from "./eventListEdit.vue?vue&type=style&index=0&id=36cf2330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf2330",
  null
  
)

export default component.exports